<template lang="pug">
  div
    sidebar
      transition-group.group-list(name="list-complete" mode="out-in" tag="ul")
        li.list-complete-item(v-if="menuAuth.includes('profile')" key="profile")
          router-link.group-link(:to="{name: 'profile'}")
            span {{$t('profile')}}
        li.list-complete-item(v-if="menuAuth.includes('department')" key="groups1")
          router-link.group-link(:to="{name: 'user-department'}")
            span {{$t('user_page.department_member_management')}}
        li.list-complete-item(v-if="menuAuth.includes('managers')" key="managers")
          router-link.group-link(:to="{name: 'managers'}")
            span {{$t('users')}}
    div.lmm-content-body
      router-view
</template>

<script>
import Sidebar from '@/components/mixins/sidebar'
import store from '@/api/store'
import {user} from '@/api/access'

export default {
  name: "manage-component",
  components: { sidebar: Sidebar },
  computed: {
    networkType() {
      return store.get("networkType")
    },
    accountType() {
      return store.get('auth').account_type
    },
    menuAuth() {
      const isExternal = this.networkType.indexOf("e") === 0
      const isCorporate = this.accountType === 1
      const userInfo = user()
      
      if (isExternal) {
        return ['profile']
      }
      
      switch (userInfo.type) {
        case 'Manager':
          return isCorporate
              ? ['profile', 'department', 'managers']
              : ['profile', 'managers']
        case 'SubManager':
          return ['profile', 'managers']
        default:
          return ['profile']
      }
    },
  },
  methods: {
    getUserData() {
      let stored = store.get("summary")
      this.summary = stored
    },
  },
  created() {
    this.getUserData()
  },
  data() {
    return {
      summary: {},
      user: user(),
    }
  },
}
</script>
